module.exports = __webpack_public_path__ + "static/media/RedDTCIcon.f7960612.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scan/RedDTCIcon.svg
// module id = 774
// module chunks = 0